import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { FactorsModel, TypeToAvaliacaoModel } from '../../../../domain/models'
import { fetchAllFactors, fetchTypeToService } from '../../../../main/usecases'

import { goToUrl } from '../../../utils'
import { useModalBox } from '../../../contexts'
import { Button, SelectInput } from '../../../components'

import * as S from './styles'

export type FactorsDataProps = {
  typeToService: number
  cdFactor: number
}

const FilterCustomFactorModal = () => {
  const [loading, setLoading] = useState(false)
  const [typeToFactor, setTypeToFactor] = useState<FactorsModel[]>()
  const [typeToService, setTypeToService] = useState<TypeToAvaliacaoModel[]>()
  const [documentsData, setDocumentsData] = useState<FactorsDataProps>(
    {} as FactorsDataProps
  )
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const history = useHistory()

  const optionsListFactors = useMemo(
    () =>
      typeToFactor?.map((item) => {
        return {
          value: item?.cdFator,
          label: item?.fator
        }
      }),
    [typeToFactor]
  )

  const optionsListServices = useMemo(
    () =>
      typeToService?.map((item) => {
        return { value: item?.cdTipoAvaliacao, label: item?.tipoAvaliacao }
      }),
    [typeToService]
  )

  const handleFilterCustomDocument = async (
    factor?: FactorsModel,
    typeToService?: TypeToAvaliacaoModel
  ) => {
    try {
      setLoading(true)
      goToUrl(history, `/fator`, {
        cdFactor: factor && factor.cdFator,
        cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
        factorTitle: factor && factor.fator,
        serviceTitle: typeToService && typeToService.tipoAvaliacao
      })

      modalClose(true)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar o fator personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const dataToTypeToDocuments = await fetchAllFactors().load()
        const dataToTypeToServices = await fetchTypeToService().load()
        setTypeToFactor(dataToTypeToDocuments)
        setTypeToService(dataToTypeToServices)
        setDocumentsData({
          cdFactor: dataToTypeToDocuments[0].cdFator,
          typeToService: dataToTypeToServices[0].cdTipoAvaliacao
        })
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return (
    <S.ModalInfo>
      <SelectInput
        labelColor="#4F4F4F"
        label="Fator*"
        name="cdFactor"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            cdFactor: Number(e.target.value)
          }))
        }
        value={documentsData?.cdFactor}
        options={optionsListFactors}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo do avaliação*"
        name="typeToService"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            typeToService: Number(e.target.value)
          }))
        }
        value={documentsData?.typeToService}
        options={optionsListServices}
      />
      <Button
        disabled={loading}
        onClick={() =>
          handleFilterCustomDocument(
            typeToFactor?.find(
              (item) => item.cdFator === documentsData.cdFactor
            ),
            typeToService?.find(
              (item) => item.cdTipoAvaliacao === documentsData.typeToService
            )
          )
        }
      >
        Filtrar
      </Button>
    </S.ModalInfo>
  )
}

export default FilterCustomFactorModal
